import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxCollection, RxDatabase, RxDocument, RxJsonSchema } from 'rxdb'
import { createCollection } from "@/data/utils/migration.ts";

export const TX_VOID_LOG_COLLECTION_NAME = 'tx_void_log'

export const VERSION = 2
const txLogSchema = {
  title: 'txVoid schema',
  version: VERSION,
  primaryKey: '_id',
  type: 'object',
  properties: {
    _id: { type: 'string', maxLength: 24 },
    type: { type: 'string', maxLength: 50 },
    orderId: { type: 'string' },
    metadata: { type: 'object', properties: {} },
  },
  indexes: [],
  required: ['_id', 'type', 'orderId'],
} as const satisfies RxJsonSchema<any>

export interface TxVoidLog extends ExtractDocumentTypeFromTypedRxJsonSchema<typeof txLogSchema> {}

export type TxVoidLogDocument = RxDocument<TxVoidLog>
export const TxVoidLogCollection: RxCollection<TxVoidLog> = {} as RxCollection<TxVoidLog>

export const createTxVoidCollection = async <T>(database: RxDatabase<T>) => {
  return await createCollection({
    database,
    collection: TxVoidLogCollection,
    collectionName: TX_VOID_LOG_COLLECTION_NAME,
    version: VERSION,
    schema: txLogSchema,
  });
}
